define('SearchSpring.ItemSearcher.View', [
    'SearchSpring.Facets.Translator',
    'SearchSpring.ItemSearcher.Results.View',
    'SearchSpring.TypeAhead.Model',
    'SearchSpring.Facets.Model',
    'SC.Configuration',
    'Profile.Model',
    'AjaxRequestsKiller',
    'ItemsSearcher.View',
    'jQuery',
    'Backbone',
    'underscore',
    'LoyaltyPrice.Helper',
    'Utils'
], function SearchSpringItemSearcherView(
    Translator,
    TypeAheadSearchSpringView,
    TypeaheadModel,
    SearchSpringFacetsModel,
    Configuration,
    ProfileModel,
    AjaxRequestsKiller,
    ItemsSearcherView,
    jQuery,
    Backbone,
    _,
    LoyaltyPriceHelper,
    Utils
) {
    'use strict';

    return ItemsSearcherView.extend({
        events: {
            'mouseover [data-hover]': 'mouseOver',
            'click [data-toggle=did-you-mean]': 'didYouMean'
        },
        didYouMean: function didYouMean(e) {
            var $el;
            var query;
            e.preventDefault();
            e.stopPropagation();

            $el = jQuery(e.currentTarget);
            query = $el.data('query');
            this.$searchElement.val(query);

            this.executeSearch(query);
        },
        overField: '',
        overValue: '',
        mouseOver: function mouseOver(e) {
            var $el = jQuery(e.target);
            var term = $el.data('term');
            var field = $el.data('field');
            var value = $el.data('value');
            var facets = {};

            if (term) {
                if (this.searchVal !== term) {
                    this.searchVal = term;
                    this.termsSearch(term);
                }
            }

            if (field && value) {
                if (this.overField !== field || (this.overField === field && this.overValue !== value)) {
                    this.overField = field;
                    this.overValue = value;
                    facets['filter.' + field] = value;
                    this.termsSearch(this.searchVal, facets);
                }
            }
        },
        cleanSearch: function cleanSearch() {
            this.$searchElement.typeahead('val', '');
            this.options.query = '';
            this.options.selectedItem = null;
            this.hideTypaheadSearch();
        },
        showTypeahead: function showTypeahead() {
            this.typeAheadView.searchVal = this.$searchElement.val();
            this.scrollTop();
            this.executeSearch(this.$searchElement.val());
        },
        scrollTop: _.throttle(function scrollTopThrottle() {
            if (jQuery(window).width() < 768) {
                jQuery('html, body').animate({ scrollTop: 0 }, 300);
                jQuery('.header-main-container').css('position', 'static');
            }
        }, 500),
        getFacets: function getFacets() {
            var translator = new Translator(
                null,
                { keywords: this.searchVal },
                // eslint-disable-next-line no-underscore-dangle
                this.options.application.translatorConfig
            );
            var facetsToShow = [];
            var allFacets = this.model.get('facets') || [];
            var facet;
            var excludedFacetFields = Configuration.get('facetsExtra.exclude') || [];
            var excludedTypeaheadFacetFields = Configuration.get('searchspring.exclude') || [];
            var isShopping = this.options.application.name === 'Shopping';
            var i = 0;
            var currentCategory;
            var itemTypeFacet;
            var priceLevelFacet;
            var priceLevelMapping = Configuration.get('searchspring.priceLevelMapping') || [];

            for (i = 0; i < allFacets.length && facetsToShow.length < 3; i++) {
                facet = allFacets[i];
                if (facet && excludedFacetFields.indexOf(facet.id) === -1 && facet.active !== 1 && excludedTypeaheadFacetFields.indexOf(facet.id) < 0) {
                    priceLevelFacet = _.findWhere(priceLevelMapping, {
                        searchspringid: facet.id
                    });
                    if (!priceLevelFacet) {
                        facetsToShow.push(facet);
                    }

                }
            }

            currentCategory = this.options.application.getCurrentCategory && this.options.application.getCurrentCategory(true);
            // facets['filter.custitem_item_type'] = 'Item';

            itemTypeFacet = _.find(allFacets, function findFacet(f) {
                return f.field === 'custitem_item_type';
            });

            if (itemTypeFacet && itemTypeFacet.values && itemTypeFacet.values.length > 1) {
                itemTypeFacet.label = 'Type';
                facetsToShow.push(itemTypeFacet);
            }

            _.each(facetsToShow, function eachFacetToShow(f) {
                f.values = _.sortBy(f.values, function (r) { return r.count * -1; });
                f.values = _.first(f.values, 3);
                _.each(f.values, function eachVal(value) {
                    var tValue = translator.cloneForFacetId(f.field, value.value);
                    value.url = isShopping ? tValue.getUrl() : encodeURIComponent(tValue.getUrl());
                });
            });

            return facetsToShow;
        },
        getSearchTerms: function getSearchTerms() {
            var self = this;
            var isShopping;
            var mapped;

            if (!this.model.terms) {
                return [];
            }
            isShopping = this.options.application.name === 'Shopping';
            mapped = _.map(this.model.terms, function mapTerms(t) {
                // eslint-disable-next-line no-underscore-dangle
                var translator = new Translator(
                    null,
                    { keywords: t.replace('<em>', '').replace('</em>', '') },
                    // eslint-disable-next-line no-underscore-dangle
                    self.options.application.translatorConfig
                );
                return {
                    text: t.replace('<em>', '').replace('</em>', ''),
                    html: t,
                    active: self.searchVal === (t.replace('<em>', '').replace('</em>', '')),
                    url: isShopping ? translator.getUrl() : encodeURIComponent(translator.getUrl())
                };
            });
            return mapped;
        },
        msrpPrice: function msrpPrice(item) {
            var profile = ProfileModel.getInstance();
            var store = profile.get('store');
            var mrspPriceLevel = store.get('msrpPriceLevelSSKey');
            var isPackItem = item.get('saleunit') !== 'Unit';
            var itemPrice = parseFloat(item.get('_price'));
            var oldMrspPriceLevel = mrspPriceLevel;
            if (isPackItem) {
                mrspPriceLevel = mrspPriceLevel.replace('_0', '_1');
            }
            return {
                msrpPrice: item.get(mrspPriceLevel) || item.get(oldMrspPriceLevel),
                showMsrp: item.get(mrspPriceLevel) ? itemPrice < parseFloat(item.get(mrspPriceLevel)) :
                    item.get(oldMrspPriceLevel) && itemPrice < parseFloat(item.get(oldMrspPriceLevel))
            };
        },
        getItems: function getItems(model) {
            var self = this;
            var profile = ProfileModel.getInstance();
            return _.first(_.map(model.get('items').models || [], function mapModels(i) {
                var priceRange = i.get('ss_price_range');
                var range = priceRange && priceRange.length > 1 ? {
                    min: priceRange[0],
                    max: priceRange[1]
                } : false;
                var msrpPrice = self.msrpPrice(i);
                var loyaltyData = LoyaltyPriceHelper.getContextForPriceView(i.toJSON(), profile);
                return {
                    name: i.get('_name'),
                    url: i.get('_url'),
                    image: i.get('thumbnailImageUrl'),
                    price: i.get('_price'),
                    msrp: msrpPrice.msrpPrice,
                    showMsrp: msrpPrice.showMsrp,
                    priceRange: range,
                    customContext: loyaltyData
                };
            }), 3);
        },
        getDidYouMean: function (model) {
            var didYouMean = model.get('didYouMean');

            if (didYouMean && didYouMean.query) {
                return didYouMean.query;
            }
            return '';
        },
        getRedirect: function (model) {
            var redir = model.get('merchandising') && model.get('merchandising').redirect;

            if (redir) {
                if (
                    redir.indexOf('http://applejack.com/') === 0 ||
                    redir.indexOf('http://www.applejack.com/') === 0 ||
                    redir.indexOf('https://applejack.com/') === 0 ||
                    redir.indexOf('https://www.applejack.com/') === 0
                ) {
                    redir = redir.replace('http://applejack.com', '')
                        .replace('https://applejack.com', '')
                        .replace('http://www.applejack.com', '')
                        .replace('https://www.applejack.com', '');
                }

                if (redir.indexOf('https://') === 0 || redir.indexOf('https://') === 0) {
                    return {
                        url: redir,
                        type: 'EXTERNAL'
                    };
                }
                return {
                    url: redir,
                    type: 'INTERNAL'
                };
            }
            return null;
        },
        executeSearch: function executeSearch(term) {
            var self = this;
            var killerId = AjaxRequestsKiller.getKillerId();
            var autocomplete = new TypeaheadModel();
            this.model = new SearchSpringFacetsModel();

            autocomplete.fetch({
                killerId: killerId,
                data: { query: term }
            }).done(function onDone() {
                var text = ((autocomplete.get('terms') && autocomplete.get('terms')[0])
                    || term).replace('<em>', '').replace('</em>', '');
                self.searchVal = text;

                self.model.terms = JSON.parse(JSON.stringify(autocomplete.get('terms'))) || [];
                self.subModel = null;

                if (self.model.terms.length === 0) {
                    self.model.terms.push(term);
                }

                self.termsSearch(text, {}, killerId);
            });
        },
        termsSearch: function termsSearch(term, pFacets, killerid) {
            var self = this;
            var model;
            var facets;
            var currentCategory;

            if (_.keys(pFacets) && _.keys(pFacets).length) {
                this.subModel = new SearchSpringFacetsModel();
                model = this.subModel;
            } else {
                model = this.model;
            }
            currentCategory = this.options.application.getCurrentCategory && this.options.application.getCurrentCategory(true);
            facets = _.extend({}, pFacets);

            // facets['filter.custitem_item_type'] = 'Item';

            if (currentCategory) {
                facets['bgfilter.commercecategory_ids'] = currentCategory.get('internalid');
            }


            facets['sort.custitem_sorting_sales'] = 'desc';
            model.fetch({
                killerId: killerid || AjaxRequestsKiller.getKillerId(),
                data: _.extend({ q: term }, facets)
            }).done(function doneFetch() {
                var redirect = self.getRedirect(model);

                if (redirect) {
                    if (redirect.type === 'INTERNAL') {
                        Backbone.history.navigate(redirect.url, { trigger: true, replace: true });
                    } else {
                        window.location.href = redirect.url;
                    }
                }

                self.typeAheadView.data = {
                    searchVal: term,
                    didYouMean: self.getDidYouMean(model),
                    items: self.getItems(model),
                    terms: self.getSearchTerms(),
                    facets: self.getFacets()
                };
                if (self.$searchElement.val().length >= self.options.minLength) {
                    self.typeAheadView.render();
                    self.$searchElement.after(self.typeAheadView.$el);
                }
            });
        },
        hideTypaheadSearch: function hideTypaheadSearch() {
            self.$('[data-type="typeahead"]').remove();
            if (jQuery(window).width() < 768) {
                jQuery('.header-main-container').css('position', 'fixed');
            }
        },
        configureTypeahead: function configureTypeahead() {
            var self = this;
            var minLength = this.options.minLength;
            this.autocomplete = new TypeaheadModel();
            this.model = new SearchSpringFacetsModel();
            self.$searchElement = self.$('[data-type="search-input"]');
            self.typeAheadView = new TypeAheadSearchSpringView();
            self.$searchElement.on('keyup', function searchKeyUP() {
                self.hideTypaheadSearch();
                if (self.$searchElement.val().length >= minLength) {
                    self.showTypeahead();
                }
            });

            jQuery(document).on('click', function onClickOutside(e) {
                var $el = jQuery(e.target);

                if (!$el.closest('.site-search-content-input').length) {
                    self.hideTypaheadSearch();
                }
            });

            Backbone.history.on('all', function onNavigation() {
                self.hideTypaheadSearch();
            });
        }
    });
});
